import PropTypes from "prop-types"
import React, { useState, useEffect, useContext } from "react"
import { Collapse, Offcanvas, OffcanvasHeader, OffcanvasBody } from "reactstrap"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"
import { toggleLeftmenu } from "../../store/actions";
//i18n
import { withTranslation } from "react-i18next"

import { connect } from "react-redux"
import { commonRoutes } from "routes/common_routes";
import classNames from "classnames"
import { getPermission, getUser } from "common/utility";
import { PERMISSION } from "common/permission";
import { fiancierRoutes } from "../../routes/finacier";
import { fiancierOpRoutes } from "../../routes/financier_operation";
import { customerRoutes } from "routes/customer";

const Navbar = props => {
  const [orderOpen, setOrderOpen] = useState(false);
  const [routes, setRoutes] = useState([]);

  useEffect(() => {
    let matchingMenuItem = null
    let ul = document.getElementById("navigation")
    let items = ul.getElementsByTagName("a")
    removeActivation(items)
    for (let item of items) {
      if (window.location.pathname === item.pathname) {
        matchingMenuItem = item
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  })

  const removeActivation = items => {
    for (let item of items) {
      const parent = item.parentElement
      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        if (parent.classList.contains("active")) {
          parent.classList.remove("active")
        }
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    if (parent) {
      parent.classList.add("active")
      const parent2 = parent.parentElement
      parent2.classList.add("active")
      const parent3 = parent2.parentElement
      if (parent3) {
        parent3.classList.add("active")
        const parent4 = parent3.parentElement
        if (parent4) {
          parent4.classList.add("active")
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("active")
            const parent6 = parent5.parentElement
            if (parent6) {
              parent6.classList.add("active")
            }
          }
        }
      }
    }
    return false
  }

  const [open, setOpen] = useState(false)

  const toggleLeftCanvas = () => {
    setOpen(!open)
  }

  const [openMenu, setOpenMenu] = useState(null);

  const handleMenuClick = (index) => {
    if (openMenu === index) {
      setOpenMenu(null); // Close the menu if it's already open
    } else {
      setOpenMenu(index); // Open the clicked menu
    }
  };
  useEffect(() => {
    fetchPermissions();
  }, []);

  const fetchPermissions = async () => {
    const rolesPermission = await getPermission();

    const roleName = await getUser('roleName');

    let rouList = []
    if (roleName == "fundLync_cutomer") {
      rouList = customerRoutes
    } else
      if (roleName == 'financier_admin') {
        rouList = fiancierRoutes
      } else if (roleName == 'financier_operations') {
        rouList = fiancierOpRoutes
      }
      else {
        rouList = commonRoutes(roleName)
      }
    const allRouters = Object.assign([...rouList]);
    const cloneRouter = allRouters.map((r) => {
      if (r.submenu?.length > 0) {
        return { ...r, submenu: [...r.submenu] };
      } else return { ...r };
    });
    const allRoutes = chechMenuPermission(rolesPermission, cloneRouter);
    setRoutes(allRoutes);
  };

  const chechMenuPermission = (rolesPermission, routerList) => {
    return (
      routerList
        .filter((r) => !r.hideMenu)
        .filter((route) => {
          let isPagePermission = false;
          if (route.submenu?.length > 0) {
            const submenu = chechMenuPermission(rolesPermission, route.submenu);
            route.submenu = submenu;
            isPagePermission = submenu?.length > 0;
          } else {
            const { permission, action } = route;
            isPagePermission = isMenuPermissionExist(
              rolesPermission,
              permission,
              action
            );
          }
          return isPagePermission;
        }) || []
    );
  };

  const isMenuPermissionExist = (rolesPermission, permission, action) => {
    const pagePermission = rolesPermission.find(
      (p) => p.permission_name === permission
    );
    return (
      pagePermission &&
      (pagePermission[action] == PERMISSION.PERMISSION_STATUS.ALLOWED ||
        pagePermission[action] ===
        PERMISSION.PERMISSION_STATUS.SOME_OTHER_STATUS)
    );
  };

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
            id="navigation"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
              style={{ backgroundColor: '#21aa47' }}
            >
              <ul className="navbar-nav">
                {routes.map(
                  (nav, i) =>
                    !nav.hideMenu && (
                      <li className="nav-item dropdown" key={i}>
                        {nav.submenu ? (
                          <>
                            <Link
                              className="nav-link dropdown-toggle arrow-none"
                              onClick={() => handleMenuClick(i)}
                              to={"#"}
                            >
                              <i className={`${nav.icon} me-2`}></i>
                              {props.t(nav.displayName)}
                              <div className="arrow-down"></div>
                            </Link>
                            <div
                              style={{
                                backgroundColor: '#21aa47',
                                color: 'white',
                                paddingLeft: '15px',
                              }}
                              className={classNames("dropdown-menu", { show: openMenu === i })}
                            >
                              {nav.submenu.map((subItem, j) => (
                                <Link
                                  key={j}
                                  className="dropdown-item nav-link"
                                  to={subItem.path}
                                  onClick={() => {
                                    props.toggleLeftmenu(false);
                                    setOpenMenu(null);
                                  }}
                                >
                                  {props.t(subItem.displayName)}
                                </Link>
                              ))}
                            </div>
                          </>
                        ) : (
                          <Link
                            className="nav-link"
                            to={nav.path}
                            onClick={() => {
                              props.toggleLeftmenu(false);
                            }}
                          >
                            <i className={`${nav.icon} me-2`}></i>
                            {props.t(nav.displayName)}
                          </Link>
                        )}
                      </li>
                    )
                )}
              </ul>

            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  )
}

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  location: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
  orderOpen: PropTypes.bool,
  toggleLeftmenu: PropTypes.func
}

const mapStatetoProps = state => {
  const { leftMenu } = state.Layout
  return { leftMenu }
}

export default withRouter(
  connect(mapStatetoProps, { toggleLeftmenu })(withTranslation()(Navbar))
)

